import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Icon, Tag, message, Modal, Button, Select } from 'antd'
import moment from 'moment'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import ColoredCard from '../colored-card'
import TotalCostChart from './total-cost-chart'
import ServicesUsage from './services-usage'
import CostlyTransfers from './costly-transfers'

import './styles.scss'

class Overview extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      loading,
      computeCost,
      storageCost,
      totalCost,
      forecast,
      totalCostChart,
      servicesUsage,
      costlyTransfers
    } = this.props
    return (
      <div className="overview">
        <div className="cards">
          <ColoredCard
            icon={<Icon type="cloud" />}
            number={computeCost.value && computeCost.value.toFixed(2)}
            unit="$"
            title={'Compute Cost'}
            color={'blue'}
            loading={loading}
            error={computeCost.error}
          />
          <ColoredCard
            icon={<Icon type="cloud" />}
            number={storageCost.value && storageCost.value.toFixed(2)}
            unit="$"
            title={'Storage Cost'}
            color={'yellow'}
            loading={loading}
            error={storageCost.error}
          />

          <ColoredCard
            icon="dollar"
            number={totalCost.value && totalCost.value.toFixed(2)}
            unit="$"
            title={'Total Cost'}
            color={'green'}
            loading={loading}
            error={totalCost.error}
          />
          <ColoredCard
            icon="dollar"
            number={forecast.value && forecast.value.toFixed(2)}
            unit="$"
            title={'Forecast'}
            color={'pink'}
            loading={loading}
            error={forecast.error}
          />
        </div>
        <div className="stats">
          <TotalCostChart
            loading={loading}
            error={totalCostChart.error}
            data={totalCostChart.data}
          />
          <ServicesUsage
           loading={loading}
           error={false}
           data={servicesUsage} />
          <CostlyTransfers
            loading={loading}
            error={false}
            data={costlyTransfers}
          />
        </div>
      </div>
    )
  }
}

export default Overview
